export type NotificationFilterId = "all" | "promotions" | "payments"

export function matchesNotificationFilter(
  type: string,
  filter: NotificationFilterId
): boolean {
  if (filter === "all") return true
  if (filter === "promotions") return type === "promotions"
  return type === "transactional" || type === "transactional-warning"
}
